var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(("height:" + _vm.height + ";")),attrs:{"id":_vm.id,"items":_vm.items,"dimensions":_vm.dimensions}})}
var staticRenderFns = []

export { render, staticRenderFns }